import { render, staticRenderFns } from "./WorkFilesTable.vue?vue&type=template&id=6ab77406&scoped=true"
import script from "./WorkFilesTable.vue?vue&type=script&lang=js"
export * from "./WorkFilesTable.vue?vue&type=script&lang=js"
import style0 from "./WorkFilesTable.vue?vue&type=style&index=0&id=6ab77406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab77406",
  null
  
)

export default component.exports